// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._1K0xKFlE3XhuIq8I1FpjrW {\n    width: 100vw;\n    height: 100vh;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n  }\n  ._21qBYvi1wyLFQ2lvKpGD4N {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n  }\n", ""]);
// Exports
exports.locals = {
	"app": "_1K0xKFlE3XhuIq8I1FpjrW",
	"canvasWrapper": "_21qBYvi1wyLFQ2lvKpGD4N"
};
module.exports = exports;
